/**
 * Runtime loader for pdfjs-dist 4.x.
 * Loaded via native ESM (bypasses webpack 4 / Angular 10, which cannot parse optional chaining in pdf.mjs).
 */

export interface PdfJsLib {
  GlobalWorkerOptions: { workerSrc: string };
  getDocument: (
    src: string | { url: string } | { data: Uint8Array } | Uint8Array
  ) => { promise: Promise<PDFDocumentProxy> };
}

export interface PDFDocumentProxy {
  numPages: number;
  getPage(pageNumber: number): Promise<PDFPageProxy>;
  destroy(): Promise<void>;
}

export interface PageViewport {
  width: number;
  height: number;
}

export interface PDFPageProxy {
  getViewport(params: { scale: number }): PageViewport;
  render(params: {
    canvasContext: CanvasRenderingContext2D;
    viewport: PageViewport;
  }): { promise: Promise<void> };
  cleanup(): void;
}

const PDF_JS_URL = '/assets/pdfjs/pdf.min.mjs';
export const PDF_WORKER_URL = '/assets/pdfjs/pdf.worker.min.mjs';

let loadPromise: Promise<PdfJsLib> | null = null;

/** Native dynamic import — webpack must not rewrite this. */
function nativeImport(url: string): Promise<PdfJsLib> {
  // tslint:disable-next-line:no-function-constructor-with-string-args
  return new Function('u', 'return import(u)')(url) as Promise<PdfJsLib>;
}

export function loadPdfJs(): Promise<PdfJsLib> {
  if (!loadPromise) {
    loadPromise = nativeImport(PDF_JS_URL).then((pdfjs) => {
      if (!pdfjs.GlobalWorkerOptions.workerSrc) {
        pdfjs.GlobalWorkerOptions.workerSrc = PDF_WORKER_URL;
      }
      return pdfjs;
    });
  }
  return loadPromise;
}
